import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import DrillDown from 'highcharts/modules/drilldown';
import Highcharts from "@material-ui/core/es/styles/withStyles";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);
DrillDown(ReactHighcharts.Highcharts);

var config = {
    chart: {
        type: 'pie'
    },
    title: {
        text: 'Uso de correções'
    },
    subtitle: {
        text: 'Clique nas fatias para ver detalhes.'
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b><br/>'
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format: '{point.name}: {point.y:.0f}'
            }
        }

    }
};

export default function RaspaCorrectionUsageChart(prop) {
    const { series } = prop;

    console.log('sidecorrection series', series);

    if (series) {
        let sLeft = [];
        let sRight = [];
        let sAdv = [];
        let sNoCorrection = [];

        let cLeft = 0;
        let cRight = 0;
        let cAdv = 0;
        let cNoCorrection = 0;

        series.map(i => {
            if (i.side === 'LEFT') {
               sLeft.push([
                   i.value.toString(),
                   i.count
               ]);
               cLeft += i.count;
            }
            if (i.side === 'RIGHT') {
                sRight.push([
                    i.value.toString(),
                    i.count
                ]);
                cRight += i.count;
            }
            if (i.side === 'ADVANCE') {
                sAdv.push([
                    i.value.toString(),
                    i.count
                ]);
                cAdv += i.count;
            }
            if (i.side === 'NO CORRECTION') {
                sNoCorrection.push([
                    i.value.toString(),
                    i.count
                ]);
                cNoCorrection += i.count
            }


        })

        config = {
            ...config,

            series: [
                {
                    name: 'Correcoes',
                    colorByPoint: true,
                    data: [
                        {
                            name: 'Esquerda',
                            y: cLeft,
                            drilldown: 'Esquerda'
                        },
                        {
                            name: 'Direita',
                            y: cRight,
                            drilldown: 'Direita'
                        },
                        {
                            name: 'Avanco',
                            y: cAdv,
                            drilldown: 'Avanco'
                        },
                        {
                            name: 'Sem Correcao',
                            y: cNoCorrection,
                            drilldown: null
                        }
                    ]
                }

            ],
            drilldown: {
                series: [
                    {
                        name: 'Esquerda',
                        id: 'Esquerda',
                        data: sLeft
                    },
                    {
                        name: 'Direita',
                        id: 'Direita',
                        data: sRight
                    },
                    {
                        name: 'Avanco',
                        id: 'Avanco',
                        data: sAdv
                    }

                ]

            }

        }

    }

    //console.log('SideCorrectionChart left:',sLeft)

    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
